import katex from "katex";

const equations = document.querySelectorAll("[data-latex]")
equations.forEach((element) => {
    katex.render(element.dataset.latex, element, {
        throwOnError: false,
        displayMode: element.tagName === "DIV"
    });
});
